// extracted by mini-css-extract-plugin
export default {"popupBody":"NetworkAlert_popupBody__f7eF0","closeBtn":"NetworkAlert_closeBtn__z2PjE","networkAlert":"NetworkAlert_networkAlert__N7xM7","errorImage":"NetworkAlert_errorImage__Jr0TZ"};